<template>
    <div class="modal fade" id="viewPreviousLoanRecord">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header bg-aqua">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <button @click="printPreviousLoanRecord()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button>
              
            </div>
            <div class="modal-body" id="printPreviousLoanRecord">
              <!-- right column -->
              <div class="row">
                
                <div class="col-md-12">
                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile" v-if="seeRecord.member">
                      <table class="table printing">
                        <thead>
                          <td width="18%"><img :src="logo" height="90" width="100%"></td>
                          <td class="text-center"><h4><strong>{{getCompanyRecord.companyName}}</strong> <br> <small>Address : {{getCompanyRecord.address}}, {{getCompanyRecord.city}}, {{getCompanyRecord.state}} - {{getCompanyRecord.pin}}
                            <br>CIN : {{getCompanyRecord.cin}}, Website - {{getCompanyRecord.url}}, Mobile No - {{getCompanyRecord.phone}}, Email ID - {{getCompanyRecord.email}}
                            </small><br><br><strong>Previous Loan Records</strong></h4></td>
                        
                        </thead>
                      </table>
                      
                      
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                  <div class="box-body">
                    <p v-if="seeRecord.member">Customer Name : {{seeRecord.member.name}}</p>
                    <table class="table table-sm table-bordered table-hover">
                        <thead style="background-color: #d6dddd;">
                        <tr>
                            <th class="hidden-xs">Sr. No.</th>
                            <th>LoanID </th>
                            <th class="hidden-xs">Type</th>
                            <th class="hidden-xs">CenterName</th>
                            <th class="hidden-xs">Branch</th>
                            <th class="hidden-xs">Disb Date</th>
                            <th>Amount</th>
                            <th class="hidden-xs">Rec. Amt</th>
                            <th class="hidden-xs">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, index) in memberloanplans" :key="index">
                            <td class="hidden-xs">{{ (index + 1) }}</td>
                            <td>{{ row.applicationNo }}</td>
                            <td class="hidden-xs">{{ row.type }}</td>
                            <td class="hidden-xs"><span v-if="row.collection_center_id">{{ row.collection_center.name }} ({{ row.collection_center.centerCode }})</span></td>
                            <td class="hidden-xs">{{ row.branch.name }}</td>
                            <td class="hidden-xs">{{ row.disbursement.disbursementDate | myDate}}</td>
                            <td>{{ row.totalAmt }}</td>
                            <td class="hidden-xs">{{ row.receivedAmt }}</td>
                            <td class="hidden-xs">
                            <span class="label label-warning" v-if="row.status == 'pending'">{{ row.status }}</span>
                            <span class="label label-info" v-if="row.status == 'processing'">{{ row.status }}</span>
                            <span class="label label-danger" v-if="row.status == 'sattlement'">{{ row.status }}</span>
                            <span class="label label-success" v-if="row.status == 'complete'">{{ row.status }}</span>
                        </td>
                        </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
                <!-- /.col -->
                
              </div>
            </div>
            <div class="modal-footer text-center">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
              >
                CLOSE
              </button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
    
</template>
<script>
import { Printd } from 'printd'
import VueBarcode from 'vue-barcode'
export default {
  name: 'PreviousLoanRecord',
  data () {
    return {
      cssText: `.printing {
        font-family: sans-serif;
        text-align: center;
        padding-bottom: 2rem;

        print-color-adjust: exact;
        -webkit-print-color-adjust: exact;
      }
      p {
        text-align: justify;
      }
      @page {
        size: A4;
        margin: 2;
      }
      table.center {
        margin-left: auto; 
        margin-right: auto;
      }
      table, th, td { border:1px solid #000; padding:0.5em; border-collapse: collapse; }`
    }
  },
  methods: {
    printPreviousLoanRecord () {
      const d = new Printd()
      d.print(document.getElementById('printPreviousLoanRecord'), [this.cssText])
    }
  },
  components: {
    'barcode': VueBarcode
  },
  props: {
    seeRecord: {},
    memberDetail: {},
    logo: '',
    getCompanyRecord: {},
    memberloanplans: {}
  }
}
</script>



// WEBPACK FOOTER //
// PreviousLoanRecord.vue?8630614c